<template>
  <div class="cards-wrap">
    <template v-if="loadingState">
      <div class="tabContent">
        <div class="loading-spinner-ct">
          <div class="loading-spinner"></div>
          <span>{{ 'Loading...' }}</span>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="header-filter">
        <div class="tag-ct">
          <template v-for="(tag, key) in all_tags">
            <span
              v-bind:key="key"
              class="tag"
              v-on:click="toggleTag(tag.tag_key)"
              v-bind:class="{ 'is-active': selected_tags.indexOf(tag.tag_key) >= 0 }"
              >{{ tag.name }}</span
            >
          </template>
        </div>
        <div class="filter-right">
          <div class="custom-select-xyz">
            <select v-model="selected_classification" v-on:change="applyFilter()">
              <option value>Filter by classification...</option>
              <option
                v-for="(cls, key) in all_classifications"
                v-bind:key="key"
                :value="cls.classification_key"
                >{{ cls.content.text }}</option
              >
            </select>
          </div>

          <div class="search-ct">
            <input
              type="text"
              placeholder="Search..."
              class="search-header"
              v-model="searchTerm"
              v-on:keyup="applyFilter()"
            />
            <i
              class="material-icons"
              v-if="searchTerm.length > 0"
              v-on:click="
                searchTerm = ''
                applyFilter()
              "
              >close</i
            >
          </div>
        </div>
      </div>
      <div class="cards-ct">
        <template>
          <div class="groupBox last">
            <div class="visible">
              <div class="row-ct-home" v-if="filteredApps.length < 1">
                <h3 style="font-weight: normal;">
                  There are no products in matching your search."
                </h3>
              </div>
              <div class="row-ct-home" v-if="filteredApps.length > 0">
                <div class="row" v-for="(app, aIdx) in filteredApps" :key="aIdx">
                  <a
                    :href="app.url"
                    :target="app.target || '_self'"
                    style="width: 100%;"
                    v-if="!app.tabs && app.url"
                    @click="checkFav($event, null)"
                  >
                    <AppCard
                      :app="app"
                      :favorites="favorites"
                      @filterFavorites="applyFilterByFav($event)"
                    ></AppCard>
                  </a>
                  <a
                    href="javascript:;"
                    v-if="app.tabs && app.tabs.length > 0"
                    :target="app.target || '_self'"
                    @click="checkFav($event, `/product/${app.key}/${app.tabs[0].path}`)"
                  >
                    <AppCard
                      :app="app"
                      :favorites="favorites"
                      @filterFavorites="applyFilterByFav($event)"
                    ></AppCard>
                  </a>
                  <div v-if="app.tabs && !app.tabs.length && !app.url">
                    <AppCard
                      :app="app"
                      :favorites="favorites"
                      @filterFavorites="applyFilterByFav($event)"
                    ></AppCard>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
// @ is an alias to /src
import HttpService from '@/services/http.service'
import AppCard from '@/components/home/AppCard.vue'

export default {
  name: 'insights',
  props: {
    config: null,
    view_mode: null,
  },
  components: {
    AppCard,
  },
  data: function() {
    return {
      all_classifications: [],
      selected_classification: '',
      selected_tags: [],
      all_tags: [],
      searchTerm: '',
      loadingState: false,
      filteredApps: [],
      cacheData: [],
      cachedApps: [],
      favorites: [],
    }
  },
  created: async function() {
    await this.getApps()
    this.applyFilter()
  },
  watch: {
    view_mode() {
      this.applyFilter()
    },
  },
  computed: {
    baseUrl() {
      return ''
    },
  },
  methods: {
    checkFav(ev, to) {
      if (ev.target.innerHTML === 'grade') {
        ev.preventDefault()
        return
      }
      this.$router.push({
        path: to,
      })
    },
    applyFilterByFav(favs) {
      this.favorites = favs
      this.applyFilter()
    },
    filterByFav() {
      this.cachedApps.map((na) => {
        const inFav = this.favorites.indexOf(na.db_id) >= 0
        na.isFavorite = inFav
      })

      let favApps = []
      let newApps = []
      let updatedApps = []
      let restApps = []
      // apply fav order
      this.cachedApps.map((na) => {
        const inFav = this.favorites.indexOf(na.db_id) >= 0
        na.isFavorite = inFav
        if (inFav) {
          favApps.push(na)
        } else {
          if (na.isNew || na.isUpdated) {
            if (na.isNew) {
              newApps.push(na)
            }
            if (na.isUpdated && !na.isNew) {
              updatedApps.push(na)
            }
          } else {
            restApps.push(na)
          }
        }
      })
      this.cachedApps = [...favApps, ...newApps, ...updatedApps, ...restApps]
      this.filteredApps = [...this.cachedApps]
    },
    buildUrl(image) {
      return `/api/fs/product/${image}`
    },
    toggleSection: function(index) {
      this.expanded[index] = !this.expanded[index]
    },
    async applyFilter() {
      this.cachedApps = JSON.parse(JSON.stringify([...this.cacheData]))
      this.filterByName()
      this.filterByTag()
      this.filterByClassification()
      this.filterByMode()
      this.filterByFav()
    },
    filterByName() {
      const searchValue = this.searchTerm
      const apps = [...this.cachedApps]
      const newApps = []
      if (searchValue.length > 0) {
        apps.map((app) => {
          if (app['name'].toLowerCase().indexOf(searchValue.toLowerCase()) !== -1) {
            newApps.push(app)
          } else {
            if (app['description'].toLowerCase().indexOf(searchValue.toLowerCase()) !== -1) {
              newApps.push(app)
            }
          }
        })
        this.cachedApps = [...newApps]
      }
      this.filteredApps = [...this.cachedApps]
    },
    filterByTag() {
      const searchValue = this.selected_tags
      if (searchValue.length < 1) {
        // temp = [...this.cachedApps]
      } else {
        const apps = [...this.cachedApps]
        const newApps = []
        apps.map((app) => {
          if (app.tags) {
            app.tags.map((t) => {
              if (searchValue.indexOf(t) !== -1) {
                const exists = newApps.filter((ga) => ga.key === app.key)[0] || null
                if (!exists) {
                  newApps.push(app)
                }
              }
            })
          }
        })
        this.cachedApps = [...newApps]
      }
      this.filteredApps = [...this.cachedApps]
    },
    filterByClassification() {
      const searchValue = this.selected_classification
      if (searchValue.length > 0) {
        const apps = [...this.cachedApps]
        const newApps = []
        apps.map((app) => {
          if (
            app['classification'] &&
            app['classification'].toLowerCase().indexOf(searchValue.toLowerCase()) !== -1
          ) {
            newApps.push(app)
          }
        })
        this.cachedApps = [...newApps]
      }
      this.filteredApps = [...this.cachedApps]
    },
    filterByMode() {
      let searchValue = ''
      try {
        searchValue = JSON.parse(sessionStorage.getItem('view_mode'))
        searchValue = searchValue.key || ''
      } catch (e) {
        // cannot parse
      }
      const apps = [...this.cachedApps]
      let newApps = []
      if (searchValue && searchValue.length > 0) {
        apps.map((app) => {
          if (app['group_security'] && app['group_security'].indexOf(searchValue.toLowerCase()) !== -1) {
            newApps.push(app)
          }
        })
      } else {
        newApps = [...this.cachedApps]
      }
      this.cachedApps = [...newApps]
      this.filteredApps = [...this.cachedApps]
    },
    toggleTag: function(tag) {
      const selected_tags = this.selected_tags
      const pos = selected_tags.indexOf(tag)
      if (pos < 0) {
        selected_tags.push(tag)
      } else {
        selected_tags.splice(pos, 1)
      }
      // run filter
      this.selected_tags = selected_tags
      this.applyFilter()
    },
    getApps: async function() {
      this.loadingState = true
      const res = await HttpService.get('/insight/getApps')
      this.loadingState = false
      let apps = res.apps
      const now = new Date().getTime()
      const all_tags = []
      const all_classifications = []
      let newApps = []
      let topApps = []
      this.favorites = res.favorites
      apps.map((d1) => {
        const d = d1.content
        if (d.visibleOnHomePage) {
          d.key = d1.app_key
          d.isFavorite = false
          d.db_id = +d1.id
          d.group_security = d1.group_security
          d.newUntil = new Date(d.newUntil)
          d.updatedUntil = new Date(d.updatedUntil)
          d.isNew = now < d.newUntil.getTime()
          d.isUpdated = now < d.updatedUntil.getTime()
          d.withStory = false
          if (d.tabs) {
            const withStory = d.tabs.filter((t) => t.path === 'story')[0] || null
            d.withStory = withStory !== null
          }
          if (d.tags) {
            d.tags.map((tag) => {
              const tg = tag.trim()
              if (all_tags.indexOf(tg) < 0 && tg && tg !== '') {
                all_tags.push(tg)
              }
            })
          }
          if (d.classification) {
            const classification = d.classification.trim()
            if (all_classifications.indexOf(classification) < 0) {
              all_classifications.push(classification)
            }
          }
          if (d.isNew || d.isUpdated) {
            topApps.push(d)
          } else {
            newApps.push(d)
          }
        }
      })
      let topNewApps = []
      let tailNewApps = []
      // apply fav order
      newApps.map((na) => {
        const inFav = this.favorites.indexOf(na.db_id) >= 0
        na.isFavorite = inFav
        if (inFav) {
          topNewApps.push(na)
        } else {
          tailNewApps.push(na)
        }
      })

      apps = [...topApps, ...topNewApps, ...tailNewApps]
      this.all_tags = res.tags.filter((t) => all_tags.indexOf(t.tag_key) >= 0)

      this.all_classifications = res.classifications.filter(
        (el) => all_classifications.indexOf(el.classification_key) >= 0
      )
      // Populate children from the router
      let expanded = {}
      this.apps = apps
      this.cacheData = JSON.parse(JSON.stringify([...apps]))
      this.expanded = expanded
    },
  },
}
</script>
<style scoped>
.tabContent {
  height: calc(100%);
}
.badge {
  background: #0a4bb7;
  color: #fff;
  padding: 3px 8px;
  font-size: 12px;
  font-weight: normal;
  margin: 0 4px;
  border-radius: 4px;
}
.badge.updated {
  background: #282f54;
}
.cards-wrap {
  display: flex;
  flex-direction: column;
  height: calc(100%);
}
.header-filter {
  height: 48px;
  background-color: #fff;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.filter-right {
  display: flex;
  align-items: center;
}
fieldset,
input,
select,
textarea {
  margin-bottom: auto;
  font-size: 12px;
  height: 30px;
}
.search-ct {
  display: flex;
  align-items: center;
  position: relative;
  margin-left: 12px;
}
.search-ct .material-icons {
  position: absolute;
  right: 6px;
  bottom: 3px;
  z-index: 2;
  cursor: pointer;
}
.search-header {
  background-color: #fff;
  width: 230px;
  font-size: 14px;
}
.cards-ct {
  display: flex;
  flex-direction: row;
  min-height: max-content;
  height: calc(100%);
}
a {
  width: 100%;
  margin-bottom: 12px;
}
a:hover {
  color: #000;
}
.row {
  margin-left: 0;
  flex-grow: 1;
  width: 30%;
  min-width: 300px;
  margin: 1em;
  max-width: 750px;
}
.loader {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.groupBox {
  background-color: white;
  padding: 0 18px;
  -webkit-box-shadow: 0 1px 5px rgba(57, 63, 72, 0.1);
  -moz-box-shadow: 0 1px 5px rgba(57, 63, 72, 0.1);
  box-shadow: 0 1px 5px rgba(57, 63, 72, 0.1);
  margin-right: 18px;
  min-width: 350px;
  width: 100%;
  height: calc(100vh - 145px);
}
.row-ct-home {
  overflow: auto;
  max-height: calc(100vh - 145px);
  margin: 0 -18px;
  padding: 19px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.visible {
  display: block;
}

.hidden {
  display: none;
}

.groupBox.last {
  margin-right: 0;
}

.sectionHeader {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 64px;
}
h2 {
  font-weight: 400;
  font-size: 180%;
}

.description {
  background-color: rgb(245, 246, 250);
  margin-bottom: 20px;
  line-height: 1.3;
  padding: 5px;
  min-height: 92px;
}
img {
  max-width: 200px;
  box-shadow: 0 1px 5px rgba(57, 63, 72, 0.1);
}
h3 {
  font-size: 100%;
  font-weight: bold;
  margin-bottom: 2px;
}
.product-actions {
  display: flex;
  justify-content: flex-start;
}
.left-side {
  width: 100% !important;
}
.button-link.blue {
  background: transparent !important;
  color: #0a4bb7 !important;
  border-radius: 0;
  border: 0px solid transparent !important;
  letter-spacing: initial;
  text-transform: none;
  padding: 0 12px;
  display: flex;
  align-items: center;
  font-size: 12px;
  font-size: 16px;
  font-weight: 400;
  line-height: 16px;
  margin-bottom: 0;
}

.button-link.blue:hover {
  color: #282f54 !important;
  text-decoration: underline;
  padding: 4px 12px;
}

.button-link.blue:focus,
.button-link.blue:active {
  padding: 4px 12px;
}

.button-link.blue span.arrow {
  background-image: url('~@/assets/images/arrow-blue.svg');
  display: block;
  width: 16px;
  height: 16px;
  margin-right: 10px;
}
.product-outer {
  padding-bottom: 24px;
  width: 100%;
}
.product-inner {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.productHR {
  border: 0;
  height: 2px;
  background: rgb(245, 246, 250);
  margin-bottom: 10px;
}
.product {
  margin-bottom: 20px;
}

.box img {
  width: 200px !important;
  height: 90px !important;
  float: right;
  margin: 12px 0px 0px 10px;
  max-width: 60%;
  height: auto;
  margin-top: 0;
}
p.productDesc {
  line-height: 1.3;
  /* text-align: justify; */
}
html,
body {
  margin: 0;
  padding: 0;
  width: calc(100vw) !important;
  overflow: hidden;
}
h2 {
  font-size: 160%;
  margin-bottom: 0rem;
}
hr {
  border: 0;
  border-top: 0.1rem solid #f5f6fa;
  margin: 0;
  margin-bottom: 12px;
}

.expander {
  display: none;
  cursor: pointer;
}

@media only screen and (min-width: 1024px) {
  .hidden {
    display: inline;
  }
}

@media only screen and (max-width: 1024px) {
  .cards-ct {
    flex-direction: column;
  }
  .groupBox {
    margin-bottom: 18px;
    min-width: auto;
  }
  .expander {
    display: inline;
  }
  .description {
    min-height: auto;
  }
  .box img {
    max-width: 40%;
  }
}
@media only screen and (max-width: 414px) {
  h2 {
    font-size: 100%;
  }
  .md-48 {
    font-size: 24px;
  }
  .content {
    padding: 8px;
  }
  .box img {
    max-width: 30%;
  }
}
</style>
